import { useNavigate } from "react-router";
import CommonButton from "../ui/CommonButton/CommonButton";
import classes from "./LoginComponent.module.css";

const LoginComponent = ({ children, login }) => {
  const navigate = useNavigate();
  return (
    <div
      className={`${classes.wrapper} d-flex align-items-center justify-content-center`}
    >
      <div className={classes.innerWrapper}>
        <div className={``}>
          <img src="/KATA-LOGO.svg" />
        </div>
        <h3>{login ? "Log into your" : "Create an"} account</h3>
        <div className="mb-4 mt-2 d-flex flex-column gap-3">{children}</div>
        {/* <CommonButton title={login ? "Log in" : "Sign up"} disable={true} /> */}
        {/* <p className="mt-3">
          {login ? "Don’t have an account? " : "Already have an account? "}
          <span onClick={() => navigate(login ? "/sign-up" : "/login")} role="button">
            {login ? "Sign up" : "Login"}
          </span>
        </p> */}
      </div>
    </div>
  );
};

export default LoginComponent;
